/** Short subtitle (2-5 words) and tooltip for each pattern type id. */
export const PATTERN_TYPE_DESCRIPTIONS = {
  type: {
    subtitle: "Video format style",
    tooltip: "How the video is built structurally, like tutorial, vlog, or review.",
  },
  format: {
    subtitle: "Creative presentation device",
    tooltip: "The reusable creative mechanic for how content is presented.",
  },
  structure: {
    subtitle: "Content beat sequence",
    tooltip: "The ordered flow of beats in the video, like hook to demo to result.",
  },
  categories: {
    subtitle: "Recurring content themes",
    tooltip: "Broad content pillars this audience returns to again and again.",
  },
  main_topic: {
    subtitle: "Video subject matter",
    tooltip: "What the video is about, grouped by specific subject matter.",
  },
  content_angle: {
    subtitle: "Positioning or stance",
    tooltip: "The copyable slant or tension, like cheap vs premium or beginner mistakes.",
  },
  tone: {
    subtitle: "Voice and delivery",
    tooltip: "The emotional register and delivery style of the content.",
  },
  audience: {
    subtitle: "Target viewer segment",
    tooltip: "The specific audience segment the video speaks to.",
  },
  language: {
    subtitle: "Spoken or text language",
    tooltip: "Primary language used in speech and on-screen text.",
  },
  hook_type: {
    subtitle: "Opening hook tactic",
    tooltip: "The classified opening tactic used to grab attention.",
  },
  hook_phrase: {
    subtitle: "Spoken hook script",
    tooltip: "The reusable spoken hook wording or script template.",
  },
  hook_visual: {
    subtitle: "Visual opening motif",
    tooltip: "The camera setup, action, or visual motif in the opening.",
  },
  cta_type: {
    subtitle: "Call to action type",
    tooltip: "The desired user action the video asks viewers to take.",
  },
  cta_style: {
    subtitle: "Call to action line",
    tooltip: "The explicit wording used for the call to action.",
  },
  hashtags: {
    subtitle: "Caption hashtags",
    tooltip: "Hashtags used in the video caption or description.",
  },
  channel_tags: {
    subtitle: "Caption mentions",
    tooltip: "Channel mentions parsed from the title or description.",
  },
  text_hook: {
    subtitle: "Caption opening hook",
    tooltip: "The opening hook formula from the platform caption or title.",
  },
  song: {
    subtitle: "Background song",
    tooltip: "The song used in the video.",
  },
  artist: {
    subtitle: "Music artist",
    tooltip: "The artist behind the song used in the video.",
  },
};

export const PATTERN_TYPE_OPTIONS = Object.keys(PATTERN_TYPE_DESCRIPTIONS).map((id) => ({
  value: id,
  label: id.replace(/_/g, " "),
}));
